import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getSettingsSection, saveSettingsSection } from '../../../../services/settingsService';

function ApplicationSettings() {
  const [settings, setSettings] = useState({
    timezone: 'UTC',
    dateFormat: 'DD/MM/YYYY',
    maintenanceMode: false
  });

  const timezones = ['UTC', 'GMT', 'EST', 'CST', 'PST', 'AEST'];
  const dateFormats = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'];

  useEffect(() => {
    getSettingsSection('application')
      .then((data) => {
        if (data && Object.keys(data).length > 0) {
          setSettings((prev) => ({ ...prev, ...data }));
        }
      })
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await saveSettingsSection('application', settings);
      toast.success('Application settings saved');
    } catch (error) {
      toast.error(error.message || 'Failed to save application settings', { autoClose: 4000 });
    }
  };

  return (
    <div className="stg-max-form">
      <div className="stg-page-header">
        <h1 className="stg-page-title">Application Settings</h1>
        <p className="stg-page-subtitle">Configure timezone, date format, and maintenance settings.</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="stg-section">
          <div className="stg-form-group">
            <label htmlFor="timezone" className="stg-form-label">Default Timezone</label>
            <select id="timezone" name="timezone" className="stg-select" value={settings.timezone} onChange={handleChange}>
              {timezones.map(tz => <option key={tz} value={tz}>{tz}</option>)}
            </select>
          </div>

          <div className="stg-form-group">
            <label htmlFor="dateFormat" className="stg-form-label">Date Format</label>
            <select id="dateFormat" name="dateFormat" className="stg-select" value={settings.dateFormat} onChange={handleChange}>
              {dateFormats.map(fmt => <option key={fmt} value={fmt}>{fmt}</option>)}
            </select>
          </div>
        </div>

        <div className="stg-section">
          <label className="stg-toggle-row">
            <input type="checkbox" name="maintenanceMode" className="stg-toggle-checkbox" checked={settings.maintenanceMode} onChange={handleChange} />
            <div className="stg-toggle-body">
              <span className="stg-toggle-label">Enable Maintenance Mode</span>
              <span className="stg-toggle-help">When enabled, only administrators can access the system.</span>
            </div>
          </label>
        </div>

        <div className="stg-actions" style={{ justifyContent: 'flex-start' }}>
          <button type="submit" className="stg-btn stg-btn-primary">Save Changes</button>
        </div>
      </form>
    </div>
  );
}

export default ApplicationSettings;
